import {
  InputNumberMinMax,
  InputNumberInteger,
  InputRadioGroup,
  InputContainer,
} from "@components-common/forms";
import { useField } from "formik";
import { Form } from "taltech-styleguide";

export const InputOrientation = (props: any) => (
  <div>
    <InputNumberMinMax
      elementClass="d-flex"
      minId="rotation.angle.options.min"
      minElementClass="w-50 pe-3 required"
      maxId="rotation.angle.options.max"
      maxElementClass="w-50 ps-3 required"
      minValue={0}
      maxValue={360}
      suffix=" °"
      {...props}
      max={360}
    />
  </div>
);

export const OrientationSelector = (props: { fieldId: string }) => {
  const [field, meta, helpers] = useField("rotation.angle.creationType");
  const body =
    field.value === "CONSTANT" ? (
      <InputNumberInteger
        id="rotation.angle.value"
        elementClass="required"
        label="Angle rotation"
        {...props}
        suffix=" °"
      />
    ) : (
      <InputOrientation {...props} />
    );

  const result = (
    <InputContainer title="Building orientation">
      <Form.Group>
        <div className="d-flex align-items-center justify-content-between">
          <div className={"d-flex align-items-center"}>
            <InputRadioGroup
              inline={true}
              showLabel={false}
              id="rotation.angle.creationType"
              options={[
                { value: "CONSTANT", text: "Constant" },
                { value: "RANDOM", text: "Random" },
              ]}
            />
          </div>
        </div>
        {body}
      </Form.Group>
    </InputContainer>
  );
  return result;
};

/* <InputContainer>
  <Form.Group className="mb-3">
    <RadioButtonComponent
      changeFn={(e) => setBuildingOrientation(+e.target.value)}
      disabled={
        buildingConfigurationFormStore.isReadOnly || config.disabled
      }
      isInline={true}
      label={"Building orientation"}
      name={"buildingOrientation"}
      options={["Fixed", "Random"]}
    />

    {buildingOrientation === 1 ? (
      <div className={"d-flex"}>
        <div className={"w-50 mr-4"}>
          <InputComponent
            isInteger={true}
            disabled={
              buildingConfigurationFormStore.isReadOnly ||
              config.disabled
            }
            type={"number"}
            label={"Min."}
            min={0}
            max={360}
            name={"orientationMin"}
          />
        </div>
        <div className={"w-50"}>
          <InputComponent
            isInteger={true}
            disabled={
              buildingConfigurationFormStore.isReadOnly ||
              config.disabled
            }
            type={"number"}
            label={"Max."}
            min={0}
            max={360}
            name={"orientationMax"}
          />
        </div>
      </div>
    ) : (
      <InputComponent
        isInteger={true}
        disabled={
          buildingConfigurationFormStore.isReadOnly || config.disabled
        }
        type={"number"}
        min={0}
        label={"Total value"}
        name={"orientationTotalValue"}
      />
    )}
  </Form.Group>
</InputContainer> */
